import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyTicketsState } from '../reducers';

export const getEditTicketState = createSelector(getDragonflyTicketsState, (state) => state.editTicket);

export const getTicket = createSelector(getEditTicketState, ({ ticket }) => ticket);

export const getTicketSeverityValues = createSelector(
  getEditTicketState,
  ({ ticketSeverityValues }) => ticketSeverityValues,
);

export const getTicketSeverity = createSelector(getEditTicketState, ({ ticketSeverity }) => ticketSeverity);

export const getStatusValues = createSelector(getEditTicketState, ({ ticketStatusValues }) => ticketStatusValues);

export const getStatus = createSelector(getEditTicketState, ({ ticketStatus }) => ticketStatus);

export const getCountryValues = createSelector(getEditTicketState, ({ countryValues }) => countryValues);

export const getCountry = createSelector(getEditTicketState, ({ country }) => country);

export const getCategoryValues = createSelector(getEditTicketState, ({ ticketCategoryValues }) => ticketCategoryValues);

export const getCategory = createSelector(getEditTicketState, ({ ticketCategory }) => ticketCategory);

export const getAssigneeValues = createSelector(getEditTicketState, ({ ticketAssigneeValues }) => ticketAssigneeValues);

export const getAssignee = createSelector(getEditTicketState, ({ ticketAssignee }) => ticketAssignee);

export const getBody = createSelector(getEditTicketState, ({ body }) => body);

export const getSubject = createSelector(getEditTicketState, ({ subject }) => subject);

export const getSearchField = createSelector(getEditTicketState, ({ searchField }) => searchField);

export const getCanCreateTicket = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tickets.action.createticket') ? true : false,
);

export const getCanUpdateTicket = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tickets.action.updateticket') ? true : false,
);

export const getIsCreateNewTicket = createSelector(
  getEditTicketState,
  getCanCreateTicket,
  ({ isCreateNewTicket }, canCreateTicket) => isCreateNewTicket && canCreateTicket,
);

export const getIsEditTicket = createSelector(
  getEditTicketState,
  getCanUpdateTicket,
  ({ isCreateNewTicket }, canUpdateTicket) => !isCreateNewTicket && canUpdateTicket,
);

export const getNoCustomerAdded = createSelector(getEditTicketState, ({ customerAdded }) => !customerAdded);

export const getCustomerAdded = createSelector(getEditTicketState, ({ customerAdded }) => customerAdded);

export const getMember = createSelector(getEditTicketState, ({ member }) => member);

export const getLoyaltyCardLength = createSelector(getMember, (member) =>
  member.length ? member[0].ticketLoyaltyMemberDto.loyaltyCardNumber.length < 13 : false,
);

export const getMemberColumns = createSelector(getEditTicketState, ({ memberColumns }) => memberColumns);

export const getCategoryValidation = createSelector(
  getCategory,
  getEditTicketState,
  (ticketCategory, { submit }) => !ticketCategory && submit,
);

export const getSubjectValidation = createSelector(
  getSubject,
  getEditTicketState,
  (subject, { submit }) => !subject && submit,
);

export const getCountryValidation = createSelector(
  getCountry,
  getEditTicketState,
  (country, { submit }) => !country && submit,
);

export const getStatusValidation = createSelector(
  getStatus,
  getEditTicketState,
  (status, { submit }) => !status && submit,
);

export const getBodyValidation = createSelector(getBody, getEditTicketState, (body, { submit }) => !body && submit);

export const getAssigneeValidation = createSelector(
  getAssignee,
  getEditTicketState,
  (assignee, { submit }) => !assignee && submit,
);

export const getSeverityValidation = createSelector(
  getTicketSeverity,
  getEditTicketState,
  (severity, { submit }) => !severity && submit,
);

export const getCreateTicketValidation = createSelector(
  getBodyValidation,
  getSubjectValidation,
  getCountryValidation,
  getCategoryValidation,
  (bodyValidation, subjectValidation, countryValidation, categoryValidation) =>
    !(bodyValidation || subjectValidation || countryValidation || categoryValidation),
);

export const getUpdateTicketValidation = createSelector(
  getBodyValidation,
  getSubjectValidation,
  getCountryValidation,
  getCategoryValidation,
  getStatusValidation,
  getAssigneeValidation,
  getSeverityValidation,
  (
    bodyValidation,
    subjectValidation,
    countryValidation,
    categoryValidation,
    statusValidation,
    assigneeValidation,
    severityValidation,
  ) =>
    !(
      bodyValidation ||
      subjectValidation ||
      countryValidation ||
      categoryValidation ||
      statusValidation ||
      assigneeValidation ||
      severityValidation
    ),
);
